import { createContext, FC, PropsWithChildren, useContext, useEffect } from "react";
import { useRolesApi } from "../http/roles/api";

export type PermissionContextType = {
  isLoading: boolean;
  hasAccess: boolean;
  isAdmin: boolean;
  error: boolean;
};

const PermissionContext = createContext<PermissionContextType>(undefined!);

type PermissionProviderProps = PropsWithChildren<{}>;

const PermissionProvider: FC<PermissionProviderProps> = ({ children }) => {
  const rolesApi = useRolesApi();

  const rolesSwr = rolesApi.useMyRoles();

  useEffect(() => {
    rolesSwr.trigger();
  }, []);

  const contextValue: PermissionContextType = {
    isLoading: !rolesSwr.data && !rolesSwr.error,
    hasAccess: !!rolesSwr.data?.length,
    isAdmin: !!rolesSwr.data?.find((x) => x.value === "admin"),
    error: !!rolesSwr.error,
  };
  return <PermissionContext.Provider value={contextValue}>{children}</PermissionContext.Provider>;
};

export const usePermissionsContext = () => {
  return useContext(PermissionContext);
};

export default PermissionProvider;
